import { render, staticRenderFns } from "./form-text-area-preview.vue?vue&type=template&id=467d50ed&scoped=true&"
import script from "./form-text-area-preview.vue?vue&type=script&lang=js&"
export * from "./form-text-area-preview.vue?vue&type=script&lang=js&"
import style0 from "./form-text-area-preview.vue?vue&type=style&index=0&id=467d50ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467d50ed",
  null
  
)

component.options.__file = "form-text-area-preview.vue"
export default component.exports